import React from "react";
import "./Footer.css";
import { FaLinkedin, FaGithub, FaMedium, FaInstagram } from "react-icons/fa";

const footer = () => {
  return (
    <>
      <section id="footer">
        <div className="footer-container">
          <div className="footer-left">
            <p>
              Created with a cup of Coffee ☕ by Hrithik
            </p>
          </div>
          <div className="footer-right">
            <div className="social-links">
              <a
                href="https://linkedin.com/in/hrithikksingh"
                target="_blank"
                aria-label="linkedin"
              >
                <FaLinkedin name="Linkedin" className="footer-social-icon"/>
              </a>
              <a
                href="https://github.com/hrithikksingh3"
                target="_blank"
                aria-label="twitter"
              >
                <FaGithub name="GitHub" className="footer-social-icon"/>
              </a>
              <a
                href="https://medium.com/@hrithikkumarsingh"
                target="_blank"
                aria-label="Medium"
              >
                <FaMedium name="Medium" className="footer-social-icon"/>
              </a>
              <a
                href="https://instagram.com/codersvoice/"
                target="_blank"
                aria-label="Instagram"
              >
                <FaInstagram name="Instagram" className="footer-social-icon"/>
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default footer;
